import {
  LOCATIONS_GET_REQUEST,
  LOCATIONS_RESET_REQUEST,
  MY_DEALER_SAVE_REQUEST,
} from "../types";

export const reqLocationsAction = ({ lang, latlng }) => ({
  type: LOCATIONS_GET_REQUEST,
  payload: { lang, latlng },
});


export const reqSaveMyDealerAction = ({ location }) => ({
  type: MY_DEALER_SAVE_REQUEST,
  payload: { location },
});


export const reqLocationsResetAction = () => ({
  type: LOCATIONS_RESET_REQUEST
});


export default {
  reqLocationsAction,
  reqLocationsResetAction,
  reqSaveMyDealerAction
};
